enum PaymentStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  COMPLETE = "COMPLETE",
  CANCELED = "CANCELED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  RETURNED = "RETURNED",
}

export default PaymentStatus;
